/**
 * The home-screen widget's one door (mobile M7): hand it "Due by month end"
 * as finished strings, or clear it. The widget is native
 * (MonthEndWidgetProvider.java) and can't run this bundle, so what it shows
 * is written here and stored on the phone. A no-op everywhere but the
 * Android app.
 *
 * The plugin is registered in a `.then` and read back afterwards, never
 * awaited itself: a Capacitor plugin is a Proxy that answers `then`.
 */

import { isAndroidApp } from "./index";

export interface MonthEndWidget {
  /** "2026-11" — the widget shows "Open MyDeck" in any other month. */
  month: string;
  label: string;
  printed: string;
  note: string;
  building: string;
  next: string;
  asOf: string;
}

type Plugin = { update(options: MonthEndWidget): Promise<void>; clear(): Promise<void> };

let plugin: Plugin | null = null;
let registering: Promise<void> | null = null;

async function register(): Promise<void> {
  registering ??= import("@capacitor/core").then(
    ({ registerPlugin }) => {
      plugin = registerPlugin<Plugin>("MonthEndWidget");
    },
    () => undefined,
  );
  await registering;
}

/** Store the widget's content, or clear it with null. Never throws. */
export async function setMonthEndWidget(data: MonthEndWidget | null): Promise<void> {
  if (!isAndroidApp()) return;
  await register();
  try {
    if (data) await plugin?.update(data);
    else await plugin?.clear();
  } catch {
    /* an older shell without the widget */
  }
}
